import { gsap } from 'gsap';
import { cursorProximityMove } from '../helper/util';
import { throttle } from 'throttle-debounce';

const customColours = {
    init(){
        const items = document.querySelectorAll('.js-has-custom-colour');        
        if (items.length > 0) {
            items.forEach(function(item) {    
                if (item.hasAttribute('data-backgroundcolour')) {
                    gsap.to(item, 1, {'background-color': item.dataset.backgroundcolour});
                }
                if (item.hasAttribute('data-textcolour')) {
                    item.classList.add(item.dataset.textcolour);
                }                
            })
        }        
    }
}

const projectProximityCursor = {
    init() {

        const canHover = window.matchMedia('(hover: hover)').matches;
        if (canHover === true) {
            const projects = document.querySelectorAll('[data-featuredprojectlink]');
            projects.forEach(function(project) {
                const img = project.querySelector('.js-featured-project-img-inner');
                const target = project.querySelector('.js-proximity-target');
                var moveDuration = 1;
                if (img.dataset.proximityduration) {
                  moveDuration = img.dataset.proximityduration;
                }                

                project.addEventListener('mouseenter', mouseEnterFunc);
                project.addEventListener('click', function(event){
                    project.removeEventListener('mouseenter', mouseEnterFunc);  
                });          
                function mouseEnterFunc(e) {
                    if (img.dataset.proximityscale) {
                      gsap.to(img, {
                        scale: img.dataset.proximityscale, 
                        duration: moveDuration
                      });      
                    }
                }                

                cursorProximityMove(target, true);
                cursorProximityMove(img, true);
            });
        }

    },
};

const projectGrid = {
	init() {
		// const parallaxIt = (e, target, movement) => {

        //     var relX = e.pageX - target.getBoundingClientRect().left;
        //     var relY = e.pageY - target.getBoundingClientRect().top;
            
        //     gsap.to(target, 0.4, {
        //           x: (relX - target.offsetWidth/2)*movement,
        //           y: (relY - target.offsetWidth/2)*movement,
        //       ease: 'power2.out'
        //     })
        //     .invalidate().restart();
  
        // }        
		// const callParallax = (e, target) => {
		//   parallaxIt(e, target, 1);
		// }        

        let projectLists = document.querySelectorAll('.js-projects');
        if (projectLists.length){
            projectLists.forEach(function(projectList) {

                let projects = projectList.querySelectorAll('.js-project');

                // let a = new Array;
                let i = 0;
                let j = 0;
                // a.push(new Array());
                async function sortProjects() {

                    for (let c = 0; c < projects.length; c++) {
                        if (projects[c].dataset.row){
                            delete projects[c].dataset.row;
                        }
                        i++;
                        let y = Math.round(projects[c].getBoundingClientRect().y);
                        let prev = projectList.querySelector(`.js-project:nth-child(${i-1})`);
                        if (i == 1){
                            // a[j].push(i);
                            projectList.querySelector(`.js-project:nth-child(${i})`).dataset.row = j+1;
                        }
                        if (prev){
                            if (Math.round(prev.getBoundingClientRect().y) == y){
                                // a[j].push(i);
                                projectList.querySelector(`.js-project:nth-child(${i})`).dataset.row = j+1;
                            } else {
                                j++;
                                // a.push(new Array());
                                // a[j].push(i);
                                projectList.querySelector(`.js-project:nth-child(${i})`).dataset.row = j+1;
                            }
                        }
                    };
                }
                sortProjects().then(() => {

                    let i = 0;

                    projects.forEach(function(project) {

                        i++;                  
                        const canHover = window.matchMedia('(hover: hover)').matches;
                        const row = project.dataset.row;
                        const others = projectList.querySelectorAll(`.js-project[data-row="${row}"]:not(:nth-child(${i}))`);
                        const duration1 = 0.25;
                        // const img = project.querySelector('.js-featured-project-img-inner');
                        // const tlThisEnter = gsap.timeline({paused: true});
                        // const tlOthersEnter = gsap.timeline({paused: true});
                        // const tlThisLeave = gsap.timeline({paused: true});
                        // const tlOthersLeave = gsap.timeline({paused: true});
                        const duration2 = duration1*0.75;
                        const scale1 = 1.1;
                        const scale2 = 0.9;
                        const heading = project.querySelector('.js-featured-project-hideme .heading');
                        const desc = project.querySelector('.js-featured-project-hideme .desc');
                        var descHeight = '';
                        if (desc !== null) {
                            descHeight = desc.offsetHeight;
                        }
                                        
                        if (canHover === true) {
                            
                            project.addEventListener('mouseenter', function() {
                                // throttleEnter(1);
                                projectEnter();
                            });		
                            // const throttleEnter = throttle(50, (num) => {
                            //     projectEnter();
                            // });
                            project.addEventListener('mouseleave', function() {
                                // throttleLeave(1);
                                projectLeave();
                            });		
                            // const throttleLeave = throttle(50, (num) => {
                            //     projectLeave();
                            // });                        
   
                            if (desc !== null) {
                                gsap.set(heading, {y: descHeight});
                            }                          
                                  
                            /* !!!!!!!!!!!!!!! */
                            // Unbind
                            /* !!!!!!!!!!!!!!! */
                            project.addEventListener('click', function(event){
                                project.removeEventListener('mouseenter', projectEnter());  
                                project.removeEventListener('mouseleave', projectLeave());  
                            });                                     

                            function projectEnter() {
                                
                                gsap.set(project, {'z-index': '10'});
                                gsap.to(project, duration1, {
                                    scale: scale1, 
                                    ease: 'power3.out',
                                    overwrite: true
                                }, 0);
                                gsap.to(heading, duration1, {
                                    y: 0,
                                }, duration1)   
                                if (desc !== null) {                                                     
                                    gsap.to(desc, duration1, {
                                        opacity: 1,
                                        overwrite: true
                                    }, duration1)       
                                }                     
                                if (others.length > 0){
                                    gsap.set(others, {'z-index': '1'})
                                    gsap.to(others, {
                                        scale: scale2, 
                                        duration: duration1,
                                        ease: 'power2.inOut',
                                        overwrite: true
                                    })  
                                }
                            }
    
                            function projectLeave() {
                                
                                gsap.set(project, {'z-index': '1'})
                                gsap.to(project, duration2, {
                                    scale: 1, 
                                    ease: 'power3.in',
                                    overwrite: true
                                }, 0)  
                                if (desc !== null) {          
                                    gsap.to(heading, duration2, {
                                        y: descHeight,
                                        overwrite: true,
                                    }, duration2)                             
                                    gsap.to(desc, duration2, {
                                        opacity: 0,
                                        overwrite: true
                                    }, 0)         
                                }
                                if (others.length > 0){                                  
                                    gsap.to(others, duration2, {
                                        scale: 1, 
                                        ease: 'power2.inOut',
                                        overwrite: true
                                    }, 0) 
                                }
                            };
                        }

                    });
                });
                

            });   

        }
	},
};

export {projectGrid, projectProximityCursor, customColours};
